var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cxr-partner-logos d-flex flex-column align-items-center mx-auto"},[_c('p',{staticClass:"m-0"},[_vm._v("In partnership with")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row"},_vm._l((_vm.logos),function(ref){
var img = ref.img;
var alt = ref.alt;
var href = ref.href;
return _c('a',{key:href,attrs:{"href":href,"target":"_blank"}},[_c('b-img',{attrs:{"fluid":"","alt":alt,"src":img}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a0fd50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/success/cxr-partner-logos.vue
// module id = qr1E
// module chunks = 2 15 32